import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AgreementsProvider } from './context/agreements-context';
import { AgreementDetailComponent } from './agreement-detail-component';

export function AgreementDetailFactory() {
    return (
        <BaseLayoutFactory>
            <AgreementsProvider>
                <AgreementDetailComponent />
            </AgreementsProvider>
        </BaseLayoutFactory>
    );
}
